<template>
  <span
    class="relative inline-flex items-center justify-between rounded-full bg-background-fg/30 px-3 py-1 text-xs font-medium text-background"
    :style="{ backgroundColor: colorHexCode }"
  >
    <template v-if="productTag?.isHidden">
      <IconEyeOff class="mr-2" />
    </template>
    {{ productTag?.label }}

    <template v-if="removable">
      <button
        type="button"
        class="ml-2 flex size-3 items-center justify-center"
        @click="emit('click-remove')"
      >
        <IconX />
      </button>
    </template>
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
  productTagId: string
  removable?: boolean
}>()

const emit = defineEmits<{
  (event: "click-remove"): void
}>()

const { getById } = useProductTags()
const productTag = computed(
  () => getById(props.productTagId).value
)

const colorHexCode = computed(() =>
  productTag.value
    ? PRODUCT_TAG_COLOR_MAP[productTag.value.color]?.color
    : undefined
)
</script>
